import { useEffect } from 'react';

import { config } from '../../config';
import { fetchFavourites } from '../../modules/favourites/actions';
import { useAppDispatch } from '../../modules/hooks';
import { useIdentity } from '../IdentityProvider/IdentityProvider';

export const useCollections = () => {
  const dispatch = useAppDispatch();
  const { isLoggedIn } = useIdentity();

  useEffect(() => {
    if (!config.enableFavourites || !isLoggedIn) {
      return;
    }

    dispatch(fetchFavourites());
  }, [dispatch, isLoggedIn]);
};
